import React, { PropsWithChildren, memo } from 'react';
import { ScrollableBody } from '../../components/Layout/ScrollableBody';
import { Spinner } from '../Spinner/Spinner';

interface ILoadingRouteProps {
    loaded: boolean;
}

export const LoadingRoute: React.FC<PropsWithChildren<ILoadingRouteProps>> = memo(({ loaded, ...props }) =>
    (loaded ? (
        <>{props.children}</>
    ) : (
        <ScrollableBody>
            <Spinner />
        </ScrollableBody>
    )),
);
